export const logos: Object = {
  'maille': '/assets/pictogrammes/maille.svg',
  'haut': '/assets/pictogrammes/haut.svg',
  'pantalon': '/assets/pictogrammes/pantalon.svg',
  'blouse': '/assets/pictogrammes/blouse.svg',
  'combinaison': '/assets/pictogrammes/cotte-combinaison.svg',
  'gilet': '/assets/pictogrammes/parka-gilet HV.svg'
};
